import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${props => props.theme.space(2.5)};
  padding: 0px ${props => `${props.theme.space(3)} ${props.theme.space(1.5)} ${props.theme.space(3)}`};
  max-width: max-content;
  color: ${props => props.theme.unisystem.tab.color};
  cursor: pointer;
  position: relative;
  border-bottom: 2px solid transparent;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    border-bottom: 1px solid
      ${props =>
        props.isSelected ? props.theme.unisystem.tab.border.selected : props.theme.unisystem.tab.border.default};
    ${props => props.isSelected && `background: ${props.theme.unisystem.tab.border.selected}`};
  }

  &:hover {
    &:after {
      height: 1px;
      background: ${props => props.theme.unisystem.tab.border.hover};
      border-bottom: 1px solid ${props => props.theme.unisystem.tab.border.hover};
    }

    & > p {
      background-color: ${props => props.theme.unisystem.tab.background.hover};
    }
  }

  & > p {
    padding: ${props => props.theme.space(1)};
    font-size: ${props => props.theme.rem(16)};
    border-radius: ${props => props.theme.space(2)};
    line-height: ${props => props.theme.rem(20)};
    font-weight: ${props => (props.isSelected ? '500' : '400')};
  }
`;
